export const PERMISSIONS_DEPENDENCIES = {
    "validate:program": [],
    "validate:special_pricing_program": [],
    "read:processing_stages": [],
    "delete:processing_stage": ["read:processing_stages"],
    "read:ready_to_settle_stages": [],
    "complete:ready_to_settle_stage": ["read:ready_to_settle_stages"],
    "read:inquiries_removal_stages": [],
    "read:lead_tab": [],
    "read:lead": [],
    "read:lead_own": [],
    "create:lead": [],
    "update:lead": [],
    "delete:lead": [],
    "create:lead_import": [],
    "update:lead_flag": [],
    "update:lead_unflag": [],
    "update:lead_checkmark": [],
    "update:lead_uncheckmark": [],
    "update:lead_telemarketer": [],
    "update:lead_telemarketer_own": [],
    "update:lead_customer_service_rep": [],
    "update:lead_customer_service_rep_own": [],
    "update:lead_agent": [],
    "update:lead_agent_own": [],
    "read:lead_details": [],
    "update:lead_convert": [],
    "update:lead_re_agent": [],
    "update:lead_re_agent_own": [],
    "update:lead_funding_agent": [],
    "update:lead_funding_agent_own": [],
    "update:lead_loan_officer": [],
    "update:lead_loan_officer_own": [],
    "read:lead_overall": [],
    "update:lead_overall": ["read:lead_overall"],
    "read:lead_ads": ["read:lead_overall"],
    "update:lead_ads": ["read:lead_ads"],
    "create:lead_credit_scores": ["read:lead_overall"],
    "update:lead_credit_scores": ["read:lead_overall"],
    "delete:lead_credit_scores": ["read:lead_overall"],
    "read:lead_program": [],
    "create:lead_program": ["read:lead_program"],
    "update:lead_program_contract_closed": ["read:lead_program"],
    "update:lead_program_status": ["read:lead_program"],
    "read:lead_program_agent_fee": ["read:lead_program"],
    "read:lead_program_price": ["read:lead_program"],
    "read:lead_program_info": ["read:lead_program"],
    "delete:lead_program": ["read:lead_program"],
    "read:lead_quotes": [],
    "create:lead_quotes": ["read:lead_quotes"],
    "update:lead_quotes": ["read:lead_quotes"],
    "delete:lead_quotes": ["read:lead_quotes"],
    "update:lead_payment_methods": [],
    "read:lead_financial": [],
    "update:lead_financial": ["read:lead_financial"],
    "read:lead_document": [],
    "import:lead_document": ["read:lead_document"],
    "delete:lead_document": ["read:lead_document"],
    "read:lead_notes": [],
    "create:lead_notes": ["read:lead_notes"],
    "update:lead_notes": ["read:lead_notes"],
    "delete:lead_notes": ["read:lead_notes"],
    "read:lead_conversation": [],
    "create:lead_conversation": ["read:lead_conversation"],
    "read:lead_activity_tab": [],

    "read:client_tab": [],
    "read:client": [],
    "read:client_own": [],
    "read:client_bankruptcy": [],
    "create:client": [],
    "update:client": [],
    "delete:client": [],
    "create:client_import": [],
    "update:client_telemarketer": [],
    "update:client_telemarketer_own": [],
    "update:client_customer_service_rep": [],
    "update:client_customer_service_rep_own": [],
    "update:client_agent": [],
    "update:client_agent_own": [],
    "update:client_flag": [],
    "update:client_unflag": [],
    "update:client_checkmark": [],
    "update:client_uncheckmark": [],
    "read:client_activity": [],
    "read:client_details": [],
    "update:client_re_agent": [],
    "update:client_re_agent_own": [],
    "update:client_funding_agent": [],
    "update:client_funding_agent_own": [],
    "update:client_loan_officer": [],
    "update:client_loan_officer_own": [],
    "read:client_production": [],
    "read:client_overall": [],
    "update:client_overall": ["read:client_overall"],
    "read:client_ads": ["read:client_overall"],
    "update:client_ads": ["read:client_ads"],
    "create:client_credit_scores": ["read:client_overall"],
    "update:client_credit_scores": ["read:client_overall"],
    "delete:client_credit_scores": ["read:client_overall"],
    "read:client_program": [],
    "create:client_program": ["read:client_program"],
    "update:client_program_contract_closed": ["read:client_program"],
    "update:client_program_status": ["read:client_program"],
    "read:client_program_agent_fee": ["read:client_program"],
    "read:client_program_price": ["read:client_program"],
    "read:client_program_info": ["read:client_program"],
    "update:client_program_info": ["read:client_program"],
    "delete:client_program": ["read:client_program"],
    "read:client_quotes": [],
    "create:client_quotes": ["read:client_quotes"],
    "update:client_quotes": ["read:client_quotes"],
    "delete:client_quotes": ["read:client_quotes"],
    "read:client_bankruptcy_tab": [],
    "update:client_bankruptcy_tab": ["read:client_bankruptcy_tab"],
    "read:client_payment": [],
    "unlock:client_payment_methods": ["read:client_payment"],
    "update:client_payment_methods": ["read:client_payment"],
    "read:client_commissions": [],
    "update:client_commissions": ["read:client_commissions"],
    "read:client_payment_transactions": ["read:client_payment"],
    "create:client_payment_transactions": ["read:client_payment"],
    "update:client_payment_transactions": ["read:client_payment"],
    "read:client_payment_re_transactions": ["read:client_payment"],
    "create:client_payment_re_transactions": ["read:client_payment"],
    "update:client_payment_re_transactions": ["read:client_payment"],
    "delete:client_payment_re_transactions": ["read:client_payment"],
    "update:client_payment_info": ["read:client_payment"],
    "read:client_payment_fees": ["read:client_payment"],
    "create:client_payment_fees": ["read:client_payment"],
    "update:client_payment_fees": ["read:client_payment"],
    "delete:client_payment_fees": ["read:client_payment"],
    "read:client_payment_fees_transactions": ["read:client_payment"],
    "create:client_payment_fees_transactions": ["read:client_payment"],
    "update:client_payment_fees_transactions": ["read:client_payment"],
    "read:client_financial": [],
    "update:client_financial": ["read:client_financial"],
    "read:client_real_estate": [],
    "update:client_real_estate": ["read:client_real_estate"],
    "read:client_re_commissions": ["read:client_real_estate"],
    "update:client_re_commissions": ["read:client_real_estate", "read:client_re_commissions"],
    "read:client_re_d_commissions": ["read:client_real_estate", "read:client_re_commissions"],
    "update:client_re_d_commissions": ["read:client_real_estate", "read:client_re_commissions", "read:client_re_d_commissions"],
    "read:client_processing": [],
    "update:client_processing": ["read:client_processing"],
    "read:client_processing_process": ["read:client_processing"],
    "create:client_processing_process": [
        "read:client_processing",
        "read:client_processing_process",
    ],
    "delete:client_processing_process": [
        "read:client_processing",
        "read:client_processing_process",
    ],
    "update:client_processing_process": [
        "read:client_processing",
        "read:client_processing_process",
    ],
    "read:client_processing_platform_access": ["read:client_processing"],
    "create:client_processing_platform_access": ["read:client_processing", "read:client_processing_platform_access"],
    "delete:client_processing_platform_access": ["read:client_processing", "read:client_processing_platform_access"],
    "update:client_processing_platform_access": ["read:client_processing", "read:client_processing_platform_access"],
    "read:client_funding": [],
    "read:client_funding_credit_lines": ["read:client_funding"],
    "create:client_funding_credit_lines": ["read:client_funding", "read:client_funding_credit_lines"],
    "delete:client_funding_credit_lines": ["read:client_funding", "read:client_funding_credit_lines"],
    "update:client_funding_credit_lines": ["read:client_funding", "read:client_funding_credit_lines"],
    "read:client_funding_bank_access": ["read:client_funding"],
    "create:client_funding_bank_access": ["read:client_funding", "read:client_funding_bank_access"],
    "delete:client_funding_bank_access": ["read:client_funding", "read:client_funding_bank_access"],
    "update:client_funding_bank_access": ["read:client_funding", "read:client_funding_bank_access"],
    "read:client_tradelines": [],
    "update:client_tradelines": ["read:client_tradelines"],
    "read:client_tradelines_tradeline": ["read:client_tradelines"],
    "create:client_tradelines_tradeline": [
        "read:client_tradelines",
        "read:client_tradelines_tradeline",
    ],
    "delete:client_tradelines_tradeline": [
        "read:client_tradelines",
        "read:client_tradelines_tradeline",
    ],
    "update:client_tradelines_tradeline": [
        "read:client_tradelines",
        "read:client_tradelines_tradeline",
    ],
    "read:client_settlements": [],
    "read:client_settlements_settlement": ["read:client_settlements"],
    "create:client_settlements_settlement": [
        "read:client_settlements",
        "read:client_settlements_settlement",
    ],
    "delete:client_settlements_settlement": [
        "read:client_settlements",
        "read:client_settlements_settlement",
    ],
    "update:client_settlements_settlement": [
        "read:client_settlements",
        "read:client_settlements_settlement",
    ],
    "create:client_settlements_notification": [
        "read:client_settlements",
        "read:client_settlements_settlement",
    ],
    "read:client_settlements_credit_card": ["read:client_settlements"],
    "create:client_settlements_credit_card": [
        "read:client_settlements",
        "read:client_settlements_credit_card",
    ],
    "delete:client_settlements_credit_card": [
        "read:client_settlements",
        "read:client_settlements_credit_card",
    ],
    "update:client_settlements_credit_card": [
        "read:client_settlements",
        "read:client_settlements_credit_card",
    ],
    "read:client_accounts": [],
    "create:client_accounts": ["read:client_accounts"],
    "delete:client_accounts": ["read:client_accounts"],
    "update:client_accounts": ["read:client_accounts"],
    "read:client_violations": [],
    "create:client_violations": ["read:client_violations"],
    "delete:client_violations": ["read:client_violations"],
    "update:client_violations": ["read:client_violations"],
    "read:client_document": [],
    "import:client_document": ["read:client_document"],
    "delete:client_document": ["read:client_document"],
    "read:client_notes": [],
    "create:client_notes": ["read:client_notes"],
    "delete:client_notes": ["read:client_notes"],
    "update:client_notes": ["read:client_notes"],
    "read:client_conversation": [],
    "create:client_conversation": ["read:client_conversation"],
    "read:client_activity_tab": [],

    "read:conversation_tab": [],
    "read:conversation": ["read:conversation_tab"],
    "read:conversation_own": ["read:conversation_tab"],
    "update:conversation_responsible": ["read:conversation_tab"],
    "update:conversation_watchers": ["read:conversation_tab"],

    "read:opportunity_tab": [],
    "read:opportunity_credit_repair": [],
    "create:opportunity_credit_repair": ["read:opportunity_credit_repair"],
    "update:opportunity_credit_repair": ["read:opportunity_credit_repair"],
    "delete:opportunity_credit_repair": ["read:opportunity_credit_repair"],
    "read:opportunity_buyer": [],
    "create:opportunity_buyer": ["read:opportunity_buyer"],
    "update:opportunity_buyer": ["read:opportunity_buyer"],
    "delete:opportunity_buyer": ["read:opportunity_buyer"],
    "read:opportunity_mortgage": [],
    "create:opportunity_mortgage": ["read:opportunity_mortgage"],
    "update:opportunity_mortgage": ["read:opportunity_mortgage"],
    "delete:opportunity_mortgage": ["read:opportunity_mortgage"],
    "read:opportunity_refinancing": [],
    "create:opportunity_refinancing": ["read:opportunity_refinancing"],
    "update:opportunity_refinancing": ["read:opportunity_refinancing"],
    "delete:opportunity_refinancing": ["read:opportunity_refinancing"],
    "read:opportunity_seller": [],
    "create:opportunity_seller": ["read:opportunity_seller"],
    "update:opportunity_seller": ["read:opportunity_seller"],
    "delete:opportunity_seller": ["read:opportunity_seller"],
    "read:opportunity_heloc": [],
    "create:opportunity_heloc": ["read:opportunity_heloc"],
    "update:opportunity_heloc": ["read:opportunity_heloc"],
    "delete:opportunity_heloc": ["read:opportunity_heloc"],

    "read:employee_tab": [],
    "read:employee": [],
    "read:employee_not_own": [],
    "create:employee": [],
    "delete:employee": [],
    "read:employee_overall": [],
    "update:employee_overall": ["read:employee_overall"],
    "read:employee_contact": [],
    "create:employee_notes": ["read:employee_contact"],
    "update:employee_notes": ["read:employee_contact"],
    "delete:employee_notes": ["read:employee_contact"],
    "import:employee_document": ["read:employee_contact"],
    "delete:employee_document": ["read:employee_contact"],
    "read:employee_commissions": [],
    "update:employee_commissions": ["read:employee_commissions"],

    "read:activity_tab": [],

    "read:campaign_tab": [],
    "read:campaign_bulk_messages": [],
    "create:campaign_bulk_messages": ["read:campaign_bulk_messages"],
    "read:campaign": [],
    "create:campaign": ["read:campaign"],
    "delete:campaign": ["read:campaign"],
    "update:campaign": ["read:campaign"],

    "read:user_tab": [],
    "read:user": [],
    "create:user": ["read:user"],
    "update:user": ["read:user"],
    "delete:user": ["read:user"],
    "reassign:user": ["read:user"],
    "update:user_role_permissions": ["read:user", "update:user"],
    "update:user_password": ["read:user", "update:user"],

    "read:calendar_tab": [],
    "read:calendar_appointments": [],
    "read:calendar_appointments_own": [],
    "create:calendar_appointments": [],
    "update:calendar_appointments": [],
    "delete:calendar_appointments": [],
    "create:calendar_appointments_other": [],
    "create:calendar_appointments_superior": ["create:calendar_appointments"],
    "create:calendar_appointments_inferior": ["create:calendar_appointments"],
    "read:calendar_appointments_assigned_by": [],
    "read:calendar_tasks": [],
    "read:calendar_tasks_own": [],
    "create:calendar_tasks": [],
    "update:calendar_tasks": [],
    "delete:calendar_tasks": [],
    "create:calendar_tasks_other": [],
    "create:calendar_tasks_superior": ["create:calendar_tasks"],
    "create:calendar_tasks_inferior": ["create:calendar_tasks"],
    "read:calendar_tasks_assigned_by": [],

    "read:settings_tab": [],
    "read:settings_dropdowns": [],
    "read:settings_round_robin": [],
    "read:settings_creditors": [],
    "read:settings_cr_pricing": [],
    "read:settings_anual_interest": [],
    "update:settings_dropdowns": ["read:settings_dropdowns"],
    "update:settings_round_robin": ["read:settings_round_robin"],
    "update:settings_creditors": ["read:settings_creditors"],
    "update:settings_cr_pricing": ["read:settings_cr_pricing"],
    "update:settings_anual_interest": ["read:settings_anual_interest"],
    "read:settings_legal_texts": [],
    "update:settings_legal_texts": ["read:settings_legal_texts"],
    "read:settings_roles": [],
    "update:settings_roles": ["read:settings_roles"],

    "read:referral_agent": [],
    "create:referral_agent": ["read:referral_agent"],
    "update:referral_agent": ["read:referral_agent"],
    "delete:referral_agent": ["read:referral_agent"],

    "read:tutorial_tab": [],
    "read:tutorial": [],
    "create:tutorial": ["read:tutorial"],
    "update:tutorial": ["read:tutorial"],
    "delete:tutorial": ["read:tutorial"],

    "read:analytics_tab": [],
    "read:analytics": [],
    "create:analytics": ["read:analytics"],
    "update:analytics": ["read:analytics"],
    "delete:analytics": ["read:analytics"],

    "read:business_tab": [],
    "read:business": [],
    "create:business": ["read:business"],
    "update:business": ["read:business"],
    "delete:business": ["read:business"],
    "read:business_bank_information": ["read:business"],
    "read:business_document": ["read:business"],
    "create:business_document": ["read:business", "read:business_document"],
    "delete:business_document": ["read:business", "read:business_document"],
    "update:business_document": ["read:business", "read:business_document"],
    "read:business_notes": ["read:business"],
    "create:business_notes": ["read:business", "read:business_notes"],
    "update:business_notes": ["read:business", "read:business_notes"],
    "delete:business_notes": ["read:business", "read:business_notes"],
    "read:business_voe": ["read:business"],

    "view:credit_sales_analytics": [],
    "view:telemarketing_analytics": [],
    "view:re_commissions_analytics": [],
    "view:ads_analytics": [],

    "read:payments": [],
    "create:payments": ["read:payments"],
    "update:payments": ["read:payments"],
    "delete:payments": ["read:payments"],

    "read:teamhub_tab": [],
    "read:teamhub_templates": ["read:teamhub_tab"],
    "read:teamhub_all_templates": ["read:teamhub_templates"],
    "create:teamhub_folders": ["read:teamhub_templates"],
    "update:teamhub_folders": ["read:teamhub_templates"],
    "delete:teamhub_folders": ["read:teamhub_templates"],
    "create:teamhub_system_templates": ["read:teamhub_templates"],
    "update:teamhub_system_templates": ["read:teamhub_templates"],
    "delete:teamhub_system_templates": ["read:teamhub_templates"],
    "create:teamhub_own_templates": ["read:teamhub_templates"],
    "update:teamhub_own_templates": ["read:teamhub_templates"],
    "delete:teamhub_own_templates": ["read:teamhub_templates"],
    "create:teamhub_team_templates": ["read:teamhub_templates"],
    "update:teamhub_team_templates": ["read:teamhub_templates"],
    "delete:teamhub_team_templates": ["read:teamhub_templates"],

    "read:teamhub_schedule_and_holidays": ["read:teamhub_tab"],
    "read:teamhub_calendar": ["read:teamhub_schedule_and_holidays"],
    "create:teamhub_calendar": ["read:teamhub_schedule_and_holidays", "read:teamhub_calendar"],
    "update:teamhub_calendar": ["read:teamhub_schedule_and_holidays", "read:teamhub_calendar"],
    "delete:teamhub_calendar": ["read:teamhub_schedule_and_holidays", "read:teamhub_calendar"],
    "read:teamhub_schedules": ["read:teamhub_schedule_and_holidays"],
    "create:teamhub_schedules": ["read:teamhub_schedule_and_holidays", "read:teamhub_schedules"],
    "update:teamhub_schedules": ["read:teamhub_schedule_and_holidays", "read:teamhub_schedules"],
    "delete:teamhub_schedules": ["read:teamhub_schedule_and_holidays", "read:teamhub_schedules"],
    "read:teamhub_vacations": ["read:teamhub_schedule_and_holidays"],
    "create:teamhub_vacations": ["read:teamhub_schedule_and_holidays", "read:teamhub_vacations"],
    "update:teamhub_vacations": ["read:teamhub_schedule_and_holidays", "read:teamhub_vacations"],
    "delete:teamhub_vacations": ["read:teamhub_schedule_and_holidays", "read:teamhub_vacations"],
    "read:teamhub_holidays": ["read:teamhub_schedule_and_holidays"],
    "create:teamhub_holidays": ["read:teamhub_schedule_and_holidays", "read:teamhub_holidays"],
    "update:teamhub_holidays": ["read:teamhub_schedule_and_holidays", "read:teamhub_holidays"],
    "delete:teamhub_holidays": ["read:teamhub_schedule_and_holidays", "read:teamhub_holidays"],

    "read:teamhub_live_attendance": ["read:teamhub_schedule_and_holidays"],
    "read:teamhub_timecard_report": ["read:teamhub_schedule_and_holidays"],

    "read:teamhub_tools": ["read:teamhub_tab"],
    "read:teamhub_tools_rdc_credit_cost_closer": ["read:teamhub_tools"],

    // Shared — Lead & Client
    "read:properties": [],
    "create:properties": ["read:properties"],
    "update:properties": ["read:properties"],
    "delete:properties": ["read:properties"],
};

export const MULTI_OPTION_PERMISSIONS_DEPENDENCIES = {
    "validate:program": [],
    "validate:special_pricing_program": [],
    "read:processing_stages": [],
    "delete:processing_stage": [],
    "read:ready_to_settle_stages": [],
    "complete:ready_to_settle_stage": [],
    "read:inquiries_removal_stages": [],

    "read:lead_tab": [],
    "read:lead": [],
    "read:lead_own": [],
    "create:lead": ["read:lead", "read:lead_own"],
    "update:lead": ["read:lead", "read:lead_own"],
    "delete:lead": ["read:lead", "read:lead_own"],
    "create:lead_import": ["read:lead", "read:lead_own"],
    "update:lead_flag": ["read:lead", "read:lead_own"],
    "update:lead_unflag": ["read:lead", "read:lead_own"],
    "update:lead_checkmark": ["read:lead", "read:own_lead"],
    "update:lead_uncheckmark": ["read:lead", "read:own_lead"],
    "update:lead_re_agent": ["read:lead", "read:lead_own"],
    "update:lead_re_agent_own": ["read:lead", "read:lead_own"],
    "update:lead_funding_agent": ["read:lead", "read:lead_own"],
    "update:lead_funding_agent_own": ["read:lead", "read:lead_own"],
    "update:lead_loan_officer": ["read:lead", "read:lead_own"],
    "update:lead_loan_officer_own": ["read:lead", "read:lead_own"],
    "update:lead_telemarketer": ["read:lead", "read:lead_own"],
    "update:lead_telemarketer_own": ["read:lead", "read:lead_own"],
    "update:lead_customer_service_rep": ["read:lead", "read:lead_own"],
    "update:lead_customer_service_rep_own": ["read:lead", "read:lead_own"],
    "update:lead_agent": ["read:lead", "read:lead_own"],
    "update:lead_agent_own": ["read:lead", "read:lead_own"],
    "read:lead_details": ["read:lead", "read:lead_own"],
    "update:lead_convert": ["read:lead", "read:lead_own"],
    "read:lead_overall": [],
    "update:lead_overall": [],
    "read:lead_ads": [],
    "update:lead_ads": [],
    "create:lead_credit_scores": [],
    "update:lead_credit_scores": [],
    "delete:lead_credit_scores": [],
    "read:lead_program": [],
    "create:lead_program": [],
    "update:lead_program_contract_closed": [],
    "update:lead_program_status": [],
    "read:lead_program_agent_fee": [],
    "read:lead_program_price": [],
    "read:lead_program_info": [],
    "delete:lead_program": [],
    "read:lead_quotes": [],
    "create:lead_quotes": [],
    "update:lead_quotes": [],
    "update:lead_payment_methods": [],
    "delete:lead_quotes": [],
    "read:lead_financial": [],
    "update:lead_financial": [],
    "read:lead_document": [],
    "import:lead_document": [],
    "delete:lead_document": [],
    "read:lead_notes": [],
    "create:lead_notes": [],
    "update:lead_notes": [],
    "delete:lead_notes": [],
    "read:lead_conversation": [],
    "create:lead_conversation": [],
    "read:lead_activity_tab": [],

    "read:client_tab": [],
    "read:client": [],
    "read:client_own": [],
    "read:client_bankruptcy": [],
    "create:client": ["read:client", "read:client_own", "read:client_bankruptcy"],
    "update:client": ["read:client", "read:client_own", "read:client_bankruptcy"],
    "delete:client": ["read:client", "read:client_own", "read:client_bankruptcy"],
    "create:client_import": ["read:client", "read:client_own", "read:client_bankruptcy"],
    "update:client_re_agent": ["read:client", "read:client_own", "read:client_bankruptcy"],
    "update:client_re_agent_own": ["read:client", "read:client_own", "read:client_bankruptcy"],
    "update:client_funding_agent": ["read:client", "read:client_own", "read:client_bankruptcy"],
    "update:client_funding_agent_own": ["read:client", "read:client_own", "read:client_bankruptcy"],
    "update:client_loan_officer": ["read:client", "read:client_own", "read:client_bankruptcy"],
    "update:client_loan_officer_own": ["read:client", "read:client_own", "read:client_bankruptcy"],
    "update:client_telemarketer": ["read:client", "read:client_own", "read:client_bankruptcy"],
    "update:client_telemarketer_own": ["read:client", "read:client_own", "read:client_bankruptcy"],
    "update:client_customer_service_rep": ["read:client", "read:client_own", "read:client_bankruptcy"],
    "update:client_customer_service_rep_own": ["read:client", "read:client_own", "read:client_bankruptcy"],
    "update:client_agent": ["read:client", "read:client_own", "read:client_bankruptcy"],
    "update:client_agent_own": ["read:client", "read:client_own", "read:client_bankruptcy"],
    "update:client_flag": ["read:client", "read:client_own", "read:client_bankruptcy"],
    "update:client_unflag": ["read:client", "read:client_own", "read:client_bankruptcy"],
    "update:client_checkmark": ["read:client", "read:client_own", "read:client_bankruptcy"],
    "update:client_uncheckmark": ["read:client", "read:client_own", "read:client_bankruptcy"],
    "read:client_activity": ["read:client", "read:client_own", "read:client_bankruptcy"],
    "read:client_details": ["read:client", "read:client_own", "read:client_bankruptcy"],
    "read:client_production": ["read:client", "read:client_own", "read:client_bankruptcy"],
    "read:client_overall": [],
    "update:client_overall": [],
    "read:client_ads": [],
    "update:client_ads": [],
    "create:client_credit_scores": [],
    "update:client_credit_scores": [],
    "delete:client_credit_scores": [],
    "read:client_program": [],
    "create:client_program": [],
    "update:client_program_contract_closed": [],
    "update:client_program_status": [],
    "read:client_program_agent_fee": [],
    "read:client_program_price": [],
    "read:client_program_info": [],
    "update:client_program_info": [],
    "read:client_quotes": [],
    "create:client_quotes": [],
    "update:client_quotes": [],
    "delete:client_quotes": [],
    "delete:client_program": [],
    "read:client_bankruptcy_tab": [],
    "update:client_bankruptcy_tab": [],
    "read:client_payment": [],
    "unlock:client_payment_methods": [],
    "update:client_payment_methods": [],
    "read:client_payment_transactions": [],
    "create:client_payment_transactions": [],
    "update:client_payment_transactions": [],
    "read:client_payment_re_transactions": [],
    "create:client_payment_re_transactions": [],
    "update:client_payment_re_transactions": [],
    "delete:client_payment_re_transactions": [],
    "update:client_payment_info": [],
    "read:client_payment_fees": [],
    "create:client_payment_fees": [],
    "update:client_payment_fees": [],
    "delete:client_payment_fees": [],
    "read:client_payment_fees_transactions": [],
    "create:client_payment_fees_transactions": [],
    "update:client_payment_fees_transactions": [],
    "read:client_financial": [],
    "update:client_financial": [],
    "read:client_commissions": [],
    "update:client_commissions": [],
    "read:client_real_estate": [],
    "update:client_real_estate": [],
    "read:client_re_commissions": [],
    "update:client_re_commissions": [],
    "read:client_re_d_commissions": [],
    "update:client_re_d_commissions": [],
    "read:client_processing": [],
    "update:client_processing": [],
    "read:client_processing_process": [],
    "create:client_processing_process": [],
    "delete:client_processing_process": [],
    "update:client_processing_process": [],
    "read:client_processing_platform_access": [],
    "create:client_processing_platform_access": [],
    "delete:client_processing_platform_access": [],
    "update:client_processing_platform_access": [],
    "read:client_tradelines": [],
    "update:client_tradelines": [],
    "read:client_tradelines_tradeline": [],
    "create:client_tradelines_tradeline": [],
    "delete:client_tradelines_tradeline": [],
    "update:client_tradelines_tradeline": [],
    "read:client_settlements": [],
    "read:client_settlements_settlement": [],
    "create:client_settlements_settlement": [],
    "delete:client_settlements_settlement": [],
    "update:client_settlements_settlement": [],
    "create:client_settlements_notification": [],
    "read:client_settlements_credit_card": [],
    "create:client_settlements_credit_card": [],
    "delete:client_settlements_credit_card": [],
    "update:client_settlements_credit_card": [],
    "read:client_accounts": [],
    "create:client_accounts": [],
    "delete:client_accounts": [],
    "update:client_accounts": [],
    "read:client_violations": [],
    "create:client_violations": [],
    "delete:client_violations": [],
    "update:client_violations": [],
    "read:client_document": [],
    "import:client_document": [],
    "delete:client_document": [],
    "read:client_notes": [],
    "create:client_notes": [],
    "delete:client_notes": [],
    "update:client_notes": [],
    "read:client_conversation": [],
    "create:client_conversation": [],
    "read:client_activity_tab": [],

    "read:conversation_tab": [],
    "read:conversation": [],
    "read:conversation_own": [],
    "update:conversation_responsible": ["read:conversation", "read:conversation_own"],
    "update:conversation_watchers": ["read:conversation", "read:conversation_own"],

    "read:opportunity_tab": [],
    "read:opportunity_credit_repair": [],
    "create:opportunity_credit_repair": [],
    "update:opportunity_credit_repair": [],
    "delete:opportunity_credit_repair": [],
    "read:opportunity_buyer": [],
    "create:opportunity_buyer": [],
    "update:opportunity_buyer": [],
    "delete:opportunity_buyer": [],
    "read:opportunity_mortgage": [],
    "create:opportunity_mortgage": [],
    "update:opportunity_mortgage": [],
    "delete:opportunity_mortgage": [],
    "read:opportunity_refinancing": [],
    "create:opportunity_refinancing": [],
    "update:opportunity_refinancing": [],
    "delete:opportunity_refinancing": [],
    "read:opportunity_seller": [],
    "create:opportunity_seller": [],
    "update:opportunity_seller": [],
    "delete:opportunity_seller": [],
    "read:opportunity_heloc": [],
    "create:opportunity_heloc": [],
    "update:opportunity_heloc": [],
    "delete:opportunity_heloc": [],

    "read:employee_tab": [],
    "read:employee": [],
    "read:employee_not_own": [],
    "create:employee": ["read:employee", "read:employee_not_own"],
    "delete:employee": ["read:employee", "read:employee_not_own"],
    "read:employee_overall": ["read:employee", "read:employee_not_own"],
    "update:employee_overall": ["read:employee", "read:employee_not_own"],
    "read:employee_contact": ["read:employee", "read:employee_not_own"],
    "create:employee_notes": ["read:employee", "read:employee_not_own"],
    "update:employee_notes": ["read:employee", "read:employee_not_own"],
    "delete:employee_notes": ["read:employee", "read:employee_not_own"],
    "import:employee_document": ["read:employee", "read:employee_not_own"],
    "delete:employee_document": ["read:employee", "read:employee_not_own"],
    "read:employee_commissions": ["read:employee", "read:employee_not_own"],
    "update:employee_commissions": ["read:employee", "read:employee_not_own"],

    "read:activity_tab": [],

    "read:campaign_tab": [],
    "create:campaign_bulk_messages": [],
    "read:campaign_bulk_messages": [],
    "read:campaign": [],
    "create:campaign": [],
    "delete:campaign": [],
    "update:campaign": [],

    "read:user_tab": [],
    "read:user": [],
    "create:user": [],
    "update:user": [],
    "delete:user": [],
    "reassign:user": [],
    "update:user_role_permissions": [],
    "update:user_password": [],

    "read:calendar_tab": [],
    "read:calendar_appointments": [],
    "read:calendar_appointments_own": [],
    "create:calendar_appointments": [
        "read:calendar_appointments",
        "read:calendar_appointments_own",
    ],
    "update:calendar_appointments": [
        "read:calendar_appointments",
        "read:calendar_appointments_own",
    ],
    "delete:calendar_appointments": [
        "read:calendar_appointments",
        "read:calendar_appointments_own",
    ],
    "create:calendar_appointments_other": [
        "read:calendar_appointments",
        "read:calendar_appointments_own",
    ],
    "create:calendar_appointments_superior": [
        "read:calendar_appointments",
        "read:calendar_appointments_own",
    ],
    "create:calendar_appointments_inferior": [
        "read:calendar_appointments",
        "read:calendar_appointments_own",
    ],
    "read:calendar_appointments_assigned_by": [
        "read:calendar_appointments",
        "read:calendar_appointments_own",
    ],
    "read:calendar_tasks": [],
    "read:calendar_tasks_own": [],
    "create:calendar_tasks": ["read:calendar_tasks", "read:calendar_tasks_own"],
    "update:calendar_tasks": ["read:calendar_tasks", "read:calendar_tasks_own"],
    "delete:calendar_tasks": ["read:calendar_tasks", "read:calendar_tasks_own"],
    "create:calendar_tasks_other": ["read:calendar_tasks", "read:calendar_tasks_own"],
    "create:calendar_tasks_superior": ["read:calendar_tasks", "read:calendar_tasks_own"],
    "create:calendar_tasks_inferior": ["read:calendar_tasks", "read:calendar_tasks_own"],
    "read:calendar_tasks_assigned_by": ["read:calendar_tasks", "read:calendar_tasks_own"],

    "read:settings_tab": [],
    "read:settings_dropdowns": [],
    "read:settings_round_robin": [],
    "read:settings_creditors": [],
    "read:settings_cr_pricing": [],
    "read:settings_anual_interest": [],
    "update:settings_dropdowns": [],
    "update:settings_round_robin": [],
    "update:settings_creditors": [],
    "update:settings_cr_pricing": [],
    "update:settings_anual_interest": [],
    "read:settings_legal_texts": [],
    "update:settings_legal_texts": [],
    "read:settings_roles": [],
    "update:settings_roles": [],

    "read:referral_agent": [],
    "create:referral_agent": [],
    "update:referral_agent": [],
    "delete:referral_agent": [],


    "read:payments": [],
    "create:payments": [],
    "update:payments": [],
    "delete:payments": [],

    "read:teamhub_tab": [],
    "read:teamhub_templates": [],
    "read:teamhub_all_templates": [],
    "create:teamhub_folders": [],
    "update:teamhub_folders": [],
    "delete:teamhub_folders": [],
    "create:teamhub_system_templates": [],
    "update:teamhub_system_templates": [],
    "delete:teamhub_system_templates": [],
    "create:teamhub_own_templates": [],
    "update:teamhub_own_templates": [],
    "delete:teamhub_own_templates": [],
    "create:teamhub_team_templates": [],
    "update:teamhub_team_templates": [],
    "delete:teamhub_team_templates": [],

    "read:teamhub_schedule_and_holidays": [],
    "read:teamhub_calendar": [],
    "create:teamhub_calendar": [],
    "update:teamhub_calendar": [],
    "delete:teamhub_calendar": [],
    "read:teamhub_schedules": [],
    "create:teamhub_schedules": [],
    "update:teamhub_schedules": [],
    "delete:teamhub_schedules": [],
    "read:teamhub_vacations": [],
    "create:teamhub_vacations": [],
    "update:teamhub_vacations": [],
    "delete:teamhub_vacations": [],
    "read:teamhub_holidays": [],
    "create:teamhub_holidays": [],
    "update:teamhub_holidays": [],
    "delete:teamhub_holidays": [],

    "read:teamhub_live_attendance": [],
    "read:teamhub_timecard_report": [],

    "read:teamhub_tools": [],
    "read:teamhub_tools_rdc_credit_cost_closer": [],

    // Shared — Lead & Client
    "read:properties": [],
    "create:properties": ["read:properties"],
    "update:properties": ["read:properties"],
    "delete:properties": ["read:properties"],
};

export const REMOVE_PERMISSIONS_DEPENDENCIES = {
    "validate:program": [],
    "validate:special_pricing_program": [],
    "read:processing_stages": ["delete:processing_stage"],
    "delete:processing_stage": [],
    "read:ready_to_settle_stages": ["complete:ready_to_settle_stage"],
    "complete:ready_to_settle_stage": [],
    "read:inquiries_removal_stages": [],

    "read:lead_tab": [],
    "read:lead": [
        "create:lead",
        "update:lead",
        "delete:lead",
        "create:lead_import",
        "update:lead_flag",
        "update:lead_unflag",
        "update:lead_checkmark",
        "update:lead_uncheckmark",
        "update:lead_telemarketer",
        "update:lead_telemarketer_own",
        "update:lead_customer_service_rep",
        "update:lead_customer_service_rep_own",
        "update:lead_re_agent",
        "update:lead_re_agent_own",
        "update:lead_funding_agent",
        "update:lead_funding_agent_own",
        "update:lead_loan_officer",
        "update:lead_loan_officer_own",
        "update:lead_agent",
        "update:lead_agent_own",
        "read:lead_details",
        "update:lead_convert",
    ],
    "read:lead_own": [
        "create:lead",
        "update:lead",
        "delete:lead",
        "create:lead_import",
        "update:lead_flag",
        "update:lead_unflag",
        "update:lead_checkmark",
        "update:lead_uncheckmark",
        "update:lead_telemarketer",
        "update:lead_telemarketer_own",
        "update:lead_customer_service_rep",
        "update:lead_customer_service_rep_own",
        "update:lead_re_agent",
        "update:lead_re_agent_own",
        "update:lead_funding_agent",
        "update:lead_funding_agent_own",
        "update:lead_loan_officer",
        "update:lead_loan_officer_own",
        "update:lead_agent",
        "update:lead_agent_own",
        "read:lead_details",
        "update:lead_convert",
    ],
    "create:lead": [],
    "update:lead": [],
    "delete:lead": [],
    "create:lead_import": [],
    "update:lead_flag": [],
    "update:lead_unflag": [],
    "update:lead_checkmark": [],
    "update:lead_uncheckmark": [],
    "update:lead_telemarketer": [],
    "update:lead_telemarketer_own": [],
    "update:lead_customer_service_rep": [],
    "update:lead_customer_service_rep_own": [],
    "update:lead_re_agent": [],
    "update:lead_re_agent_own": [],
    "update:lead_funding_agent": [],
    "update:lead_funding_agent_own": [],
    "update:lead_loan_officer": [],
    "update:lead_loan_officer_own": [],
    "update:lead_agent": [],
    "update:lead_agent_own": [],
    "read:lead_details": [],
    "update:lead_convert": [],
    "read:lead_overall": [
        "update:lead_overall",
        "read:lead_ads",
        "update:lead_ads",
        "create:lead_credit_scores",
        "update:lead_credit_scores",
        "delete:lead_credit_scores",
    ],
    "update:lead_overall": [],
    "read:lead_ads": ["update:lead_ads"],
    "update:lead_ads": [],
    "create:lead_credit_scores": [],
    "update:lead_credit_scores": [],
    "delete:lead_credit_scores": [],
    "read:lead_program": [
        "create:lead_program",
        "update:lead_program_contract_closed",
        "update:lead_program_status",
        "read:lead_program_agent_fee",
        "read:lead_program_price",
        "read:lead_program_info",
        "delete:lead_program",
    ],
    "create:lead_program": [],
    "update:lead_program_contract_closed": [],
    "update:lead_program_status": [],
    "read:lead_program_agent_fee": [],
    "read:lead_program_price": [],
    "read:lead_program_info": [],
    "delete:lead_program": [],
    "read:lead_quotes": ["create:lead_quotes", "update:lead_quotes", "delete:lead_quotes"],
    "create:lead_quotes": [],
    "update:lead_quotes": [],
    "delete:lead_quotes": [],
    "update:lead_payment_methods": [],
    "read:lead_financial": ["update:lead_financial"],
    "update:lead_financial": [],
    "read:lead_document": ["import:lead_document", "delete:lead_document"],
    "import:lead_document": [],
    "delete:lead_document": [],
    "read:lead_notes": ["create:lead_notes", "update:lead_notes", "delete:lead_notes"],
    "create:lead_notes": [],
    "update:lead_notes": [],
    "delete:lead_notes": [],
    "read:lead_conversation": ["create:lead_conversation"],
    "create:lead_conversation": [],
    "read:lead_activity_tab": [],

    "read:client_tab": [],
    "read:client": [
        "create:client",
        "update:client",
        "delete:client",
        "create:client_import",
        "update:client_re_agent",
        "update:client_re_agent_own",
        "update:client_funding_agent",
        "update:client_funding_agent_own",
        "update:client_loan_officer",
        "update:client_loan_officer_own",
        "update:client_telemarketer",
        "update:client_telemarketer_own",
        "update:client_customer_service_rep",
        "update:client_customer_service_rep_own",
        "update:client_agent",
        "update:client_agent_own",
        "update:client_flag",
        "update:client_unflag",
        "update:client_checkmark",
        "update:client_uncheckmark",
        "read:client_activity",
        "read:client_details",
        "read:client_production",
    ],
    "read:client_own": [
        "create:client",
        "update:client",
        "delete:client",
        "create:client_import",
        "update:client_re_agent",
        "update:client_re_agent_own",
        "update:client_funding_agent",
        "update:client_funding_agent_own",
        "update:client_loan_officer",
        "update:client_loan_officer_own",
        "update:client_telemarketer",
        "update:client_telemarketer_own",
        "update:client_customer_service_rep",
        "update:client_customer_service_rep_own",
        "update:client_agent",
        "update:client_agent_own",
        "update:client_flag",
        "update:client_unflag",
        "update:client_checkmark",
        "update:client_uncheckmark",
        "read:client_activity",
        "read:client_details",
        "read:client_production",
    ],
    "read:client_bankruptcy": [
        "create:client",
        "update:client",
        "delete:client",
        "create:client_import",
        "update:client_re_agent",
        "update:client_re_agent_own",
        "update:client_funding_agent",
        "update:client_funding_agent_own",
        "update:client_loan_officer",
        "update:client_loan_officer_own",
        "update:client_telemarketer",
        "update:client_telemarketer_own",
        "update:client_customer_service_rep",
        "update:client_customer_service_rep_own",
        "update:client_agent",
        "update:client_agent_own",
        "update:client_flag",
        "update:client_unflag",
        "update:client_checkmark",
        "update:client_uncheckmark",
        "read:client_activity",
        "read:client_details",
        "read:client_production",
    ],
    "create:client": [],
    "update:client": [],
    "delete:client": [],
    "create:client_import": [],
    "update:client_re_agent": [],
    "update:client_re_agent_own": [],
    "update:client_funding_agent": [],
    "update:client_funding_agent_own": [],
    "update:client_loan_officer": [],
    "update:client_loan_officer_own": [],
    "update:client_telemarketer": [],
    "update:client_telemarketer_own": [],
    "update:client_customer_service_rep": [],
    "update:client_customer_service_rep_own": [],
    "update:client_agent": [],
    "update:client_agent_own": [],
    "update:client_flag": [],
    "update:client_unflag": [],
    "update:client_checkmark": [],
    "update:client_uncheckmark": [],
    "read:client_activity": [],
    "read:client_details": [],
    "read:client_production": [],
    "read:client_overall": [
        "update:client_overall",
        "read:client_ads",
        "update:client_ads",
        "create:client_credit_scores",
        "update:client_credit_scores",
        "delete:client_credit_scores",
    ],
    "update:client_overall": [],
    "read:client_ads": ["update:client_ads"],
    "update:client_ads": [],
    "create:client_credit_scores": [],
    "update:client_credit_scores": [],
    "delete:client_credit_scores": [],
    "read:client_program": [
        "create:client_program",
        "update:client_program_contract_closed",
        "update:client_program_status",
        "read:client_program_agent_fee",
        "read:client_program_price",
        "read:client_program_info",
        "update:client_program_info",
        "delete:client_program",
    ],
    "create:client_program": [],
    "update:client_program_contract_closed": [],
    "update:client_program_status": [],
    "read:client_program_agent_fee": [],
    "read:client_program_price": [],
    "read:client_program_info": [],
    "update:client_program_info": [],
    "read:client_quotes": ["create:client_quotes", "update:client_quotes", "delete:client_quotes"],
    "create:client_quotes": [],
    "update:client_quotes": [],
    "delete:client_quotes": [],
    "delete:client_program": [],
    "read:client_bankruptcy_tab": ["update:client_bankruptcy_tab"],
    "update:client_bankruptcy_tab": [],
    "read:client_payment": [
        "unlock:client_payment_methods",
        "update:client_payment_methods",
        "read:client_payment_transactions",
        "create:client_payment_transactions",
        "update:client_payment_transactions",
        "read:client_payment_re_transactions",
        "create:client_payment_re_transactions",
        "update:client_payment_re_transactions",
        "delete:client_payment_re_transactions",
        "update:client_payment_info",
        "read:client_payment_fees",
        "create:client_payment_fees",
        "update:client_payment_fees",
        "delete:client_payment_fees",
        "read:client_payment_fees_transactions",
        "create:client_payment_fees_transactions",
        "update:client_payment_fees_transactions",
    ],
    "unlock:client_payment_methods": [],
    "update:client_payment_methods": [],
    "read:client_payment_transactions": [],
    "create:client_payment_transactions": [],
    "update:client_payment_transactions": [],
    "read:client_payment_re_transactions": [],
    "create:client_payment_re_transactions": [],
    "update:client_payment_re_transactions": [],
    "delete:client_payment_re_transactions": [],
    "update:client_payment_info": [],
    "read:client_payment_fees": [],
    "create:client_payment_fees": [],
    "update:client_payment_fees": [],
    "delete:client_payment_fees": [],
    "read:client_payment_fees_transactions": [],
    "create:client_payment_fees_transactions": [],
    "update:client_payment_fees_transactions": [],
    "read:client_financial": ["update:client_financial"],
    "update:client_financial": [],
    "read:client_commissions": ["update:client_commissions"],
    "update:client_commissions": [],
    "read:client_real_estate": ["update:client_real_estate", "read:client_re_commissions", "update:client_re_commissions", "read:client_re_d_commissions", "update:client_re_d_commissions"],
    "update:client_real_estate": [],
    "read:client_re_commissions": ["update:client_re_commissions", "read:client_re_d_commissions", "update:client_re_d_commissions"],
    "update:client_re_commissions": [],
    "read:client_re_d_commissions": ["update:client_re_d_commissions"],
    "update:client_re_d_commissions": [],
    "read:client_processing": [
        "update:client_processing",
        "read:client_processing_process",
        "create:client_processing_process",
        "delete:client_processing_process",
        "update:client_processing_process",
        "read:client_processing_platform_access",
        "create:client_processing_platform_access",
        "delete:client_processing_platform_access",
        "update:client_processing_platform_access",
    ],
    "update:client_processing": [],
    "read:client_processing_process": [
        "create:client_processing_process",
        "delete:client_processing_process",
        "update:client_processing_process",
    ],
    "create:client_processing_process": [],
    "delete:client_processing_process": [],
    "update:client_processing_process": [],
    "read:client_processing_platform_access": [
        "create:client_processing_platform_access",
        "delete:client_processing_platform_access",
        "update:client_processing_platform_access",
    ],
    "create:client_processing_platform_access": [],
    "delete:client_processing_platform_access": [],
    "update:client_processing_platform_access": [],
    "read:client_funding": [
        "read:client_funding_credit_lines",
        "create:client_funding_credit_lines",
        "delete:client_funding_credit_lines",
        "update:client_funding_credit_lines",
    ],
    "read:client_funding_credit_lines": [
        "create:client_funding_credit_lines",
        "delete:client_funding_credit_lines",
        "update:client_funding_credit_lines",
    ],
    "create:client_funding_credit_lines": [],
    "delete:client_funding_credit_lines": [],
    "update:client_funding_credit_lines": [],

    "read:client_funding_bank_access": ["create:client_funding_bank_access", "delete:client_funding_bank_access", "update:client_funding_bank_access"],
    "create:client_funding_bank_access": [],
    "delete:client_funding_bank_access": [],
    "update:client_funding_bank_access": [],
    "read:client_tradelines": [
        "update:client_tradelines",
        "read:client_tradelines_tradeline",
        "create:client_tradelines_tradeline",
        "delete:client_tradelines_tradeline",
        "update:client_tradelines_tradeline",
    ],
    "update:client_tradelines": [],
    "read:client_tradelines_tradeline": [
        "create:client_tradelines_tradeline",
        "delete:client_tradelines_tradeline",
        "update:client_tradelines_tradeline",
    ],
    "create:client_tradelines_tradeline": [],
    "delete:client_tradelines_tradeline": [],
    "update:client_tradelines_tradeline": [],
    "read:client_settlements": [
        "read:client_settlements_settlement",
        "create:client_settlements_settlement",
        "delete:client_settlements_settlement",
        "update:client_settlements_settlement",
        "create:client_settlements_notification",
        "read:client_settlements_credit_card",
        "create:client_settlements_credit_card",
        "delete:client_settlements_credit_card",
        "update:client_settlements_credit_card",
    ],
    "read:client_settlements_settlement": [
        "create:client_settlements_settlement",
        "delete:client_settlements_settlement",
        "update:client_settlements_settlement",
        "create:client_settlements_notification",
    ],
    "create:client_settlements_settlement": [],
    "delete:client_settlements_settlement": [],
    "update:client_settlements_settlement": [],
    "create:client_settlements_notification": [],
    "read:client_settlements_credit_card": [
        "create:client_settlements_credit_card",
        "delete:client_settlements_credit_card",
        "update:client_settlements_credit_card",
    ],
    "create:client_settlements_credit_card": [],
    "delete:client_settlements_credit_card": [],
    "update:client_settlements_credit_card": [],
    "read:client_accounts": [
        "create:client_accounts",
        "delete:client_accounts",
        "update:client_accounts",
    ],
    "create:client_accounts": [],
    "delete:client_accounts": [],
    "update:client_accounts": [],
    "read:client_violations": [
        "create:client_violations",
        "delete:client_violations",
        "update:client_violations",
    ],
    "create:client_violations": [],
    "delete:client_violations": [],
    "update:client_violations": [],
    "read:client_document": ["import:client_document", "delete:client_document"],
    "import:client_document": [],
    "delete:client_document": [],
    "read:client_notes": ["create:client_notes", "delete:client_notes", "update:client_notes"],
    "create:client_notes": [],
    "delete:client_notes": [],
    "update:client_notes": [],
    "read:client_conversation": ["create:client_conversation"],
    "create:client_conversation": [],
    "read:client_activity_tab": [],

    "read:conversation_tab": [],
    "read:conversation": [
        "update:conversation_responsible",
        "update:conversation_watchers",
    ],
    "read:conversation_own": [
        "update:conversation_responsible",
        "update:conversation_watchers",
    ],
    "update:conversation_responsible": [],
    "update:conversation_watchers": [],

    "read:opportunity_tab": [],
    "read:opportunity_credit_repair": ["create:opportunity_credit_repair", "update:opportunity_credit_repair", "delete:opportunity_credit_repair"],
    "create:opportunity_credit_repair": [],
    "update:opportunity_credit_repair": [],
    "delete:opportunity_credit_repair": [],
    "read:opportunity_buyer": ["create:opportunity_buyer", "update:opportunity_buyer", "delete:opportunity_buyer"],
    "create:opportunity_buyer": [],
    "update:opportunity_buyer": [],
    "delete:opportunity_buyer": [],
    "read:opportunity_mortgage": ["create:opportunity_mortgage", "update:opportunity_mortgage", "delete:opportunity_mortgage"],
    "create:opportunity_mortgage": [],
    "update:opportunity_mortgage": [],
    "delete:opportunity_mortgage": [],
    "read:opportunity_refinancing": ["create:opportunity_refinancing", "update:opportunity_refinancing", "delete:opportunity_refinancing"],
    "create:opportunity_refinancing": [],
    "update:opportunity_refinancing": [],
    "delete:opportunity_refinancing": [],
    "read:opportunity_seller": ["create:opportunity_seller", "update:opportunity_seller", "delete:opportunity_seller"],
    "create:opportunity_seller": [],
    "update:opportunity_seller": [],
    "delete:opportunity_seller": [],
    "read:opportunity_heloc": ["create:opportunity_heloc", "update:opportunity_heloc", "delete:opportunity_heloc"],
    "create:opportunity_heloc": [],
    "update:opportunity_heloc": [],
    "delete:opportunity_heloc": [],

    "read:employee_tab": [],
    "read:employee": [
        "create:employee",
        "delete:employee",
        "read:employee_overall",
        "update:employee_overall",
        "read:employee_contact",
        "create:employee_notes",
        "update:employee_notes",
        "delete:employee_notes",
        "import:employee_document",
        "delete:employee_document",
        "read:employee_commissions",
        "update:employee_commissions",
    ],
    "read:employee_not_own": [
        "create:employee",
        "delete:employee",
        "read:employee_overall",
        "update:employee_overall",
        "read:employee_contact",
        "create:employee_notes",
        "update:employee_notes",
        "delete:employee_notes",
        "import:employee_document",
        "delete:employee_document",
        "read:employee_commissions",
        "update:employee_commissions",
    ],
    "create:employee": [],
    "delete:employee": [],
    "read:employee_overall": ["update:employee_overall"],
    "update:employee_overall": [],
    "read:employee_contact": [
        "create:employee_notes",
        "update:employee_notes",
        "delete:employee_notes",
        "import:employee_document",
        "delete:employee_document",
    ],
    "create:employee_notes": [],
    "update:employee_notes": [],
    "delete:employee_notes": [],
    "import:employee_document": [],
    "delete:employee_document": [],
    "read:employee_commissions": ["update:employee_commissions"],
    "update:employee_commissions": [],

    "read:activity_tab": [],

    "read:campaign_tab": [],
    "read:campaign_bulk_messages": ["create:campaign_bulk_messages"],
    "create:campaign_bulk_messages": [],
    "read:campaign": ["create:campaign", "delete:campaign", "update:campaign"],
    "create:campaign": [],
    "delete:campaign": [],
    "update:campaign": [],
    "read:user_tab": [],
    "read:user": [
        "create:user",
        "update:user",
        "delete:user",
        "reassign:user",
        "update:user_role_permissions",
        "update:user_password",
    ],
    "create:user": [],
    "update:user": ["update:user_role_permissions", "update:user_password"],
    "delete:user": [],
    "reassign:user": [],
    "update:user_role_permissions": [],
    "update:user_password": [],

    "read:calendar_tab": [],
    "read:calendar_appointments": [
        "create:calendar_appointments",
        "update:calendar_appointments",
        "delete:calendar_appointments",
        "create:calendar_appointments_other",
        "create:calendar_appointments_superior",
        "create:calendar_appointments_inferior",
        "read:calendar_appointments_assigned_by",
    ],
    "read:calendar_appointments_own": [
        "create:calendar_appointments",
        "update:calendar_appointments",
        "delete:calendar_appointments",
        "create:calendar_appointments_other",
        "create:calendar_appointments_superior",
        "create:calendar_appointments_inferior",
        "read:calendar_appointments_assigned_by",
    ],
    "create:calendar_appointments": [],
    "update:calendar_appointments": [],
    "delete:calendar_appointments": [],
    "create:calendar_appointments_other": [],
    "create:calendar_appointments_superior": [],
    "create:calendar_appointments_inferior": [],
    "read:calendar_appointments_assigned_by": [],
    "read:calendar_tasks": [
        "create:calendar_tasks",
        "update:calendar_tasks",
        "delete:calendar_tasks",
        "create:calendar_tasks_other",
        "create:calendar_tasks_superior",
        "create:calendar_tasks_inferior",
        "read:calendar_tasks_assigned_by",
    ],
    "read:calendar_tasks_own": [
        "create:calendar_tasks",
        "update:calendar_tasks",
        "delete:calendar_tasks",
        "create:calendar_tasks_other",
        "create:calendar_tasks_superior",
        "create:calendar_tasks_inferior",
        "read:calendar_tasks_assigned_by",
    ],
    "create:calendar_tasks": [],
    "update:calendar_tasks": [],
    "delete:calendar_tasks": [],
    "create:calendar_tasks_other": [],
    "create:calendar_tasks_superior": [],
    "create:calendar_tasks_inferior": [],
    "read:calendar_tasks_assigned_by": [],

    "read:settings_tab": [],
    "read:settings_dropdowns": ["update:settings_dropdowns"],
    "read:settings_round_robin": ["update:settings_round_robin"],
    "read:settings_creditors": ["update:settings_creditors"],
    "read:settings_cr_pricing": ["update:settings_cr_pricing"],
    "read:settings_anual_interest": ["update:settings_anual_interest"],
    "read:settings_legal_texts": ["update:settings_legal_texts"],
    "read:settings_roles": ["update:settings_roles"],
    "update:settings_dropdowns": [],
    "update:settings_round_robin": [],
    "update:settings_creditors": [],
    "update:settings_cr_pricing": [],
    "update:settings_anual_interest": [],
    "update:settings_legal_texts": [],
    "update:settings_roles": [],

    "read:referral_agent": ["create:referral_agent", "update:referral_agent", "delete:referral_agent"],
    "create:referral_agent": [],
    "update:referral_agent": [],
    "delete:referral_agent": [],

    "read:tutorial": ["create:tutorial", "update:tutorial", "delete:tutorial"],
    "create:tutorial": [],
    "update:tutorial": [],
    "delete:tutorial": [],

    "read:analytics": ["create:analytics", "update:analytics", "delete:analytics", "view:credit_sales_analytics", "view:telemarketing_analytics", "view:re_commissions_analytics", "view:ads_analytics"],
    "create:analytics": [],
    "update:analytics": [],
    "delete:analytics": [],

    "read:business_tab": [],
    "read:business": [
        "create:business",
        "update:business",
        "delete:business",
        "read:business_bank_information",
        "read:business_document",
        "create:business_document",
        "delete:business_document",
        "update:business_document",
        "read:business_notes",
        "create:business_notes",
        "update:business_notes",
        "delete:business_notes",
        "read:business_voe"
    ],
    "create:business": [],
    "update:business": [],
    "delete:business": [],
    "read:business_bank_information": [],
    "read:business_document": ["create:business_document", "delete:business_document", "update:business_document"],
    "create:business_document": [],
    "delete:business_document": [],
    "update:business_document": [],
    "read:business_notes": ["create:business_notes", "update:business_notes", "delete:business_notes"],
    "create:business_notes": [],
    "update:business_notes": [],
    "delete:business_notes": [],
    "read:business_voe": [],
    "view:credit_sales_analytics": [],
    "view:telemarketing_analytics": [],
    "view:re_commissions_analytics": [],
    "view:ads_analytics": [],


    "read:payments": ["create:payments", "update:payments", "delete:payments"],
    "create:payments": [],
    "update:payments": [],
    "delete:payments": [],

    "read:teamhub_tab": [
        "read:teamhub_templates",
        "read:teamhub_all_templates",
        "create:teamhub_folders",
        "update:teamhub_folders",
        "delete:teamhub_folders",
        "create:teamhub_system_templates",
        "update:teamhub_system_templates",
        "delete:teamhub_system_templates",
        "create:teamhub_own_templates",
        "update:teamhub_own_templates",
        "delete:teamhub_own_templates",
        "create:teamhub_team_templates",
        "update:teamhub_team_templates",
        "delete:teamhub_team_templates",
        "read:teamhub_schedule_and_holidays",
        "read:teamhub_calendar",
        "create:teamhub_calendar",
        "update:teamhub_calendar",
        "delete:teamhub_calendar",
        "read:teamhub_schedules",
        "create:teamhub_schedules",
        "update:teamhub_schedules",
        "delete:teamhub_schedules",
        "read:teamhub_vacations",
        "create:teamhub_vacations",
        "update:teamhub_vacations",
        "delete:teamhub_vacations",
        "read:teamhub_holidays",
        "create:teamhub_holidays",
        "update:teamhub_holidays",
        "delete:teamhub_holidays",
        "read:teamhub_live_attendance",
        "read:teamhub_timecard_report",
        "read:teamhub_tools",
        "read:teamhub_tools_rdc_credit_cost_closer",
    ],
    "read:teamhub_templates": [
        "read:teamhub_all_templates",
        "create:teamhub_folders",
        "update:teamhub_folders",
        "delete:teamhub_folders",
        "create:teamhub_system_templates",
        "update:teamhub_system_templates",
        "delete:teamhub_system_templates",
        "create:teamhub_own_templates",
        "update:teamhub_own_templates",
        "delete:teamhub_own_templates",
        "create:teamhub_team_templates",
        "update:teamhub_team_templates",
        "delete:teamhub_team_templates",
    ],
    "read:teamhub_all_templates": [],
    "create:teamhub_folders": [],
    "update:teamhub_folders": [],
    "delete:teamhub_folders": [],
    "create:teamhub_system_templates": [],
    "update:teamhub_system_templates": [],
    "delete:teamhub_system_templates": [],
    "create:teamhub_own_templates": [],
    "update:teamhub_own_templates": [],
    "delete:teamhub_own_templates": [],
    "create:teamhub_team_templates": [],
    "update:teamhub_team_templates": [],
    "delete:teamhub_team_templates": [],

    // Schedule and Holidays permissions
    "read:teamhub_schedule_and_holidays": [
        "read:teamhub_calendar",
        "create:teamhub_calendar",
        "update:teamhub_calendar",
        "delete:teamhub_calendar",
        "read:teamhub_schedules",
        "create:teamhub_schedules",
        "update:teamhub_schedules",
        "delete:teamhub_schedules",
        "read:teamhub_vacations",
        "create:teamhub_vacations",
        "update:teamhub_vacations",
        "delete:teamhub_vacations",
        "read:teamhub_holidays",
        "create:teamhub_holidays",
        "update:teamhub_holidays",
        "delete:teamhub_holidays",
        "read:teamhub_live_attendance",
        "read:teamhub_timecard_report",
    ],
    "read:teamhub_calendar": ["create:teamhub_calendar", "update:teamhub_calendar", "delete:teamhub_calendar"],
    "create:teamhub_calendar": [],
    "update:teamhub_calendar": [],
    "delete:teamhub_calendar": [],
    "read:teamhub_schedules": [
        "create:teamhub_schedules",
        "update:teamhub_schedules",
        "delete:teamhub_schedules",
    ],
    "create:teamhub_schedules": [],
    "update:teamhub_schedules": [],
    "delete:teamhub_schedules": [],
    "read:teamhub_vacations": [
        "create:teamhub_vacations",
        "update:teamhub_vacations",
        "delete:teamhub_vacations",
    ],
    "create:teamhub_vacations": [],
    "update:teamhub_vacations": [],
    "delete:teamhub_vacations": [],
    "read:teamhub_holidays": [
        "create:teamhub_holidays",
        "update:teamhub_holidays",
        "delete:teamhub_holidays",
    ],
    "create:teamhub_holidays": [],
    "update:teamhub_holidays": [],
    "delete:teamhub_holidays": [],

    "read:teamhub_live_attendance": [],

    // Tools permissions
    "read:teamhub_tools": ["read:teamhub_tools_rdc_credit_cost_closer"],
    "read:teamhub_tools_rdc_credit_cost_closer": [],

    // Shared — Lead & Client
    "read:properties": ["create:properties", "update:properties", "delete:properties"],
    "create:properties": [],
    "update:properties": [],
    "delete:properties": [],
};
